// Application shell: sidebar navigation, a header slot and the page content (ADR-0018 chassis).
import type { ReactNode } from "react"
import { NavLink } from "react-router-dom"

import { Text, clx } from "@medusajs/ui"

export type NavItem = { to: string; label: string; icon?: ReactNode }

export function AppShell({
  productName,
  nav,
  header,
  children,
}: {
  productName: string
  nav: NavItem[]
  header?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="bg-ui-bg-subtle flex min-h-screen">
      <aside className="bg-ui-bg-base border-ui-border-base flex w-60 shrink-0 flex-col border-r">
        <div className="border-ui-border-base border-b px-4 py-3">
          <Text size="small" weight="plus" leading="compact">
            {productName}
          </Text>
        </div>
        <nav aria-label={productName} className="flex flex-col gap-y-0.5 p-2">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                clx(
                  "txt-compact-small text-ui-fg-subtle hover:bg-ui-bg-base-hover flex items-center gap-x-2 rounded-md px-2 py-1.5",
                  isActive && "bg-ui-bg-base-pressed text-ui-fg-base",
                )
              }
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="bg-ui-bg-base border-ui-border-base flex items-center justify-end gap-x-2 border-b px-6 py-2">
          {header}
        </header>
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  )
}
